/**
 * CWR 2.4 — detail-only SVG icons, copied verbatim from the confirmed mockup
 * (session-detail-layouts.html). Decorative (`aria-hidden`). The back / clock /
 * pin / modality icons are reused from catalogIcons.tsx.
 */
import type { ReactElement } from 'react';

export const ChatIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-3.8-.9L3 21l1.9-5.7a8.5 8.5 0 0 1-.9-3.8 8.38 8.38 0 0 1 8.5-8.5 8.38 8.38 0 0 1 8.5 8.5z" />
  </svg>
);

export const LocationIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
    <path d="M12 21s-7-4.3-7-10a7 7 0 0 1 14 0c0 5.7-7 10-7 10z" />
    <circle cx="12" cy="11" r="2.5" />
  </svg>
);

export const CancellationIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="1 4 1 10 7 10" />
    <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
  </svg>
);

export const ClockMetaIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <polyline points="12 7 12 12 15 14" />
  </svg>
);

// Payment terms line (sticky bar) — the mockup's card glyph.
export const PaymentIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="1" y="4" width="22" height="16" rx="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

// ── Lightbox arrows (Gabriel-requested fullscreen photo viewer — not in the
//    mockup; standard chevrons in the warm-luxe stroke style). The viewer has no
//    in-app close glyph — the Telegram BackButton + swipe-down + Esc close it. ──
export const ChevronLeftIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const ChevronRightIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
